import { render, staticRenderFns } from "./PracticeSuiteIndex.vue?vue&type=template&id=64cac6ab&scoped=true&"
import script from "./PracticeSuiteIndex.vue?vue&type=script&lang=js&"
export * from "./PracticeSuiteIndex.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSuiteIndex.vue?vue&type=style&index=0&id=64cac6ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cac6ab",
  null
  
)

export default component.exports